import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetTitle,
  SheetTrigger,
} from "../ui/sheet";
import { HambergerMenu } from "iconsax-react";
import SideBar from "../SideBar";
import { useState } from "react";

const MobileSidebar = () => {
  const [isSidebarOpen, setSidebar] = useState(false);

  return (
    <Sheet open={isSidebarOpen} onOpenChange={setSidebar}>
      <SheetTrigger asChild>
        <div
          className="lg:hidden h-9 w-9 bg-[#161616] text-[#344054] rounded-full flex items-center justify-center cursor-pointer"
          onClick={() => setSidebar(!isSidebarOpen)}
        >
          <HambergerMenu size="20" color="#F2F4F7" />
        </div>
      </SheetTrigger>
      <SheetContent side={"left"} className="bg-[#f6f8f9] w-fit">
        <SheetTitle className="hidden"></SheetTitle>

        <SheetDescription className=" hidden"></SheetDescription>

        <SideBar isSidebarOpen={isSidebarOpen} setSidebar={setSidebar} />
      </SheetContent>
    </Sheet>
  );
};

export default MobileSidebar;
